import { BaseResponse } from '@monorepo/client-common';
import {
  FailedMailOtpCodeReason,
  ReceivedMailState,
  sendMailReturnType,
} from '@monorepo/types';
import CrudService from '../core/crud-service';

export default class MailOtpService extends CrudService {
  static override route = 'mail-otp';

  async getMailOtpStatus(sourceId: string) {
    try {
      const response = await this.httpService.get<
        BaseResponse<ReceivedMailState>
      >(`${this.path}/received/${sourceId}`);

      return response.data;
    } catch (e) {
      console.error(`Failed getting received mail state for: ${sourceId}`, e);
      throw e;
    }
  }

  async sendMail(source: string, sourceId: string, displayName?: string) {
    try {
      const response = await this.httpService.post<
        Record<string, unknown>,
        BaseResponse<sendMailReturnType>
      >(`${this.path}/send/${source}/${sourceId}`, {
        displayName,
      });

      return response.data;
    } catch (e) {
      console.error(`Failed sending mail for: ${sourceId}`, e);
      throw e;
    }
  }

  async verifyMailOtp(sourceId: string, code: string) {
    try {
      const response = await this.httpService.post<
        { code: string },
        BaseResponse<{
          verified: boolean;
          reason?: FailedMailOtpCodeReason;
          tries?: number;
        }>
      >(`${this.path}/verify/${sourceId}`, {
        code,
      });

      return response.data;
    } catch (e) {
      console.error(`Failed verifying mail otp for: ${sourceId}`, e);
      throw e;
    }
  }
}
